//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.FloorPlanCartItem

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The seats extra config model
* 
* @param supportsBestAvailable ...
* @param cartId the shopping cart id
* @param shoppingCartObjects the cart objects
* @param unselectableObjects The unselectable objects.
*/
@Serializable

data class FloorPlanExtraConfig (


      /* ... */
    @SerialName(value = "supportsBestAvailable") @Required val supportsBestAvailable: kotlin.Boolean,


      /* the shopping cart id */
    @SerialName(value = "cartId") val cartId: kotlin.String? = null,


      /* the cart objects */
    @SerialName(value = "shoppingCartObjects") val shoppingCartObjects: kotlin.collections.List<FloorPlanCartItem>? = null,


      /* The unselectable objects. */
    @SerialName(value = "unselectableObjects") val unselectableObjects: kotlin.collections.List<kotlin.String>? = null


) {




  }

